// src/core/common/authSession.ts
export type UiUser = { id?: number | string; name?: string; email?: string };

export const getUserFromSession = (): UiUser | null => {
  try {
    const j = sessionStorage.getItem("user");
    return j ? JSON.parse(j) : null;
  } catch { return null; }
};

export const getUserFromLocal = (): UiUser | null => {
  try {
    const j = localStorage.getItem("user");
    return j ? JSON.parse(j) : null;
  } catch { return null; }
};

export const getUserIdFromUrl = (): number | null => {
  try {
    const url = new URL(window.location.href);
    const uid = url.searchParams.get("uid");
    return uid ? Number(uid) : null;
  } catch { return null; }
};

/** Copy user from localStorage/URL -> sessionStorage if missing (for new tabs). */
export const rehydrateSessionFromLocal = () => {
  const uidFromUrl = getUserIdFromUrl();
  if (uidFromUrl && !sessionStorage.getItem("user_id")) {
    sessionStorage.setItem("user_id", String(uidFromUrl));
  }
  if (!sessionStorage.getItem("user")) {
    const uLocal = getUserFromLocal();
    if (uLocal) {
      sessionStorage.setItem("user", JSON.stringify(uLocal));
      if (uLocal.id != null && !sessionStorage.getItem("user_id")) {
        sessionStorage.setItem("user_id", String(uLocal.id));
      }
      if (uLocal.name && !sessionStorage.getItem("user_name")) {
        sessionStorage.setItem("user_name", String(uLocal.name));
      }
    }
  }
};

/** Canonical user id getter (session → local → URL). */
export const getCurrentUserId = (): number | null => {
  const sid = sessionStorage.getItem("user_id");
  if (sid) return Number(sid);
  const su = getUserFromSession();
  if (su?.id != null) return Number(su.id);
  const lu = getUserFromLocal();
  if (lu?.id != null) return Number(lu.id);
  const fromUrl = getUserIdFromUrl();
  if (fromUrl) return fromUrl;
  return null;
};

/** Canonical user details. */
export const getCurrentUser = (): UiUser | null => {
  const su = getUserFromSession();
  if (su) return su;
  const lu = getUserFromLocal();
  return lu || null;
};
